import { useStore } from "~/mobx/utils/useStore";

export function useClinicPhoneNumber() {
  const store = useStore();
  const clinicPhoneNumber = store.uiStore.clinicPhoneNumber;
  const clinicPhoneNumberCountryCode = "+46"; // TODO: Get this from the BE

  return {
    clinicPhoneNumber,
    clinicPhoneNumberCountryCode,
  };
}
